export interface EditBarProps {
  latestToast?: string | null;
  onDone(): void;
  onOpenBackground?(): void;
  onOpenShell?(): void;
}

export function EditBar({ latestToast, onDone }: EditBarProps) {
  return (
    <div className="editbar" data-testid="editbar">
      <div className="note" data-testid="edit-note" role="status">
        {latestToast ?? "Tap a highlighted spot to change it."}
      </div>
      <button className="btn" type="button" data-testid="edit-done" onClick={onDone}>
        Done
      </button>
    </div>
  );
}
